import React, {useEffect, useState} from 'react';
import Modal from "../../components/modal/modal";

export default function AcceptFinancingModal({show, setter, selectedInvoice}) {
    const [data, setData] = useState({});

    const parseValue = (value) => {
        return parseFloat(value).toFixed(2);
    }

    useEffect(() => {
        setData(selectedInvoice.financing_details);
    }, [selectedInvoice]);

    return (
        <Modal show={show} setter={setter} size={'lg'}>
            <div style={{
                fontSize: "24px",
                textAlign: "center",
                color: "#333",
            }}>Detalles de tu financiamiento
            </div>

            <div className={'d-flex justify-content-between my-3'}>
                <div>
                    <div>collection_fee_percentage: {parseValue(data?.collection_fee_percentage)}</div>
                    <div>Moneda: {data?.currency}</div>
                    <div>facturedo_fee_percentage: {parseValue(data?.facturedo_fee_percentage)}</div>
                </div>
                <div>
                    <div>max_monthly_discount_rate: {parseValue(data?.max_monthly_discount_rate)}</div>
                    <div>min_advance_rate: {parseValue(data?.min_advance_rate)}</div>
                </div>
            </div>
        </Modal>
    )
}